import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { retailTrustBadges } from '@/mocks/corporateRetailData';

function translatedParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <>
    <section className="hero-billboard relative w-full h-[60vh] min-h-[460px] md:h-[82vh] md:min-h-[640px] overflow-hidden">
      <img
        src="/images/generated/retail-hero-x1.jpg"
        alt={t('corporateRetail.hero.imgAlt')}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 hero-overlay"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="relative w-full px-8">
          <div className="max-w-[800px] mx-auto text-center">
            <h1 className="font-heading text-2xl md:text-4xl text-foreground-50 tracking-[0.08em] mb-4">
              {t('corporateRetail.hero.title')}
            </h1>
            {String(t('corporateRetail.hero.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] md:text-[17px] tracking-[0.12em] mb-6">{__s}</p>))}
            {translatedParagraphs(
              t('corporateRetail.hero.lead'),
              'text-[15px] md:text-[16px] text-foreground-200/80 tracking-[0.05em] leading-relaxed max-w-[600px] mx-auto mb-10'
            )}

            <a
              href="#contact-form"
              className="btn-glow inline-block px-10 py-3.5 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('corporateRetail.hero.cta')}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-primary-900/70 backdrop-blur-sm">
        <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-5 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          {retailTrustBadges.map((badge, idx) => (
            <div key={idx} className="flex items-center gap-3 text-foreground-200">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${badge.icon} text-accent-400 text-sm`}></i>
              </div>
              <span className="text-[14px] tracking-[0.05em] whitespace-nowrap">{t(`corporateRetail.hero.badge${idx + 1}`)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
    <nav aria-label="パンくずリスト" className="bg-background-50 border-b border-background-200"><div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-3 flex items-center gap-2 text-[13px] text-foreground-500"><Link to="/" className="hover:text-accent-600 transition-colors">{t('corporateRetail.hero.homeLink')}</Link><i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i><Link to="/corporate" className="hover:text-accent-600 transition-colors">{t('corporateRetail.hero.corporateLink')}</Link><i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i><span className="text-foreground-700">{t('corporateRetail.hero.currentPage')}</span></div></nav>
    </>
  );
}
